var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.root},[_c('header',{class:_vm.$style.header},[_c('div',{class:_vm.$style.headerTitle},[_vm._v(_vm._s(_vm.$t(_vm.header)))])]),_c('div',{class:_vm.$style.content},[_c('ui-progress',{class:_vm.$style.load})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }